import { AppDispatch, RootState, store } from '../index';
import { FetchState } from '../fetchState';
import { getList, getListSort, ListFilter, listSlice, ListType } from '../listHelper';
import { CancelToken } from 'axios';
import { InvitedPersonDto } from '@api/models/invitation/InvitedPersonDto';
import { invitationPersonService } from '@api/services/services';
import { selectIdentityRowsCount } from './identity';

export type InvitationPersonListState = ListType<InvitedPersonDto, ListFilter>;

const initialState: InvitationPersonListState = {
  state: FetchState.None,
  data: undefined,
  query: {},
};

export const invitationPersonListSlice = listSlice({
  name: 'invitationPersonList',
  initialState,
});

export const selectInvitationPersonList = (state: RootState) => state.invitationPersonList;
export const invitationPersonListActions = invitationPersonListSlice.actions;

// Builds the persons query from the grid's current paging/search/sort so that the grid list and
// the invitation's embedded persons stay in sync. Keep all person fetches going through this helper.
export const buildInvitationPersonQuery = (invitationId: string, state: RootState) => {
  const list = selectInvitationPersonList(state);
  return {
    invitationId,
    q: list.query.q,
    page: list.query.page,
    size: selectIdentityRowsCount(state),
    sort: getListSort(list),
  };
};

export const getInvitationPersonList = (invitationId: string, cancelToken: CancelToken) => (dispatch: AppDispatch) => {
  const storeState = store.getState();
  const data = selectInvitationPersonList(storeState);

  const handleGetData = () => {
    return invitationPersonService.query(buildInvitationPersonQuery(invitationId, storeState));
  };

  getList({
    dispatch,
    cancelToken,
    state: data.state,
    actions: invitationPersonListActions,
    getData: handleGetData,
  });
};
